import classNames from 'classnames'
import { type FC } from 'react'

export type EditorMode = 'edit' | 'preview'

const MODES: Array<{ key: EditorMode; label: string }> = [
  { key: 'edit', label: 'Edit' },
  { key: 'preview', label: 'Preview' },
]

export interface EditPreviewToggleProps {
  mode: EditorMode
  onChange: (mode: EditorMode) => void
}

export const EditPreviewToggle: FC<EditPreviewToggleProps> = ({ mode, onChange }) => (
  <div role='group' aria-label='Edit or preview the email' className='d-flex overflow-hidden border rounded-2 zocks-border-color-gray-300'>
    {MODES.map(({ key, label }) => (
      <button
        key={key}
        type='button'
        aria-pressed={mode === key}
        className={classNames('border-0 px-3 py-1 paragraph-medium', {
          'zocks-bg-color-gray-900 text-white': mode === key,
          'zocks-bg-color-white zocks-text-gray-700': mode !== key,
        })}
        onClick={() => onChange(key)}
      >
        {label}
      </button>
    ))}
  </div>
)
